// extracted by mini-css-extract-plugin
export var bodyRow = "_do-d";
export var cardColumns = "_do-e";
export var ellipsesOverflow = "_do-2";
export var flatBottomCorners = "_do-3";
export var flatTopCorners = "_do-4";
export var headerActionsDropdown = "_do-f";
export var headerBottomRow = "_do-c";
export var headerTopRow = "_do-b";
export var orderDetailsWrapper = "_do-0";
export var orderInfoContainer = "_do-1";
export var productDetails = "_do-9";
export var productImage = "_do-5";
export var responsiveTable = "_do-8";
export var shipmentContainer = "_do-a";
export var tableBottomLeft = "_do-6";
export var tableBottomRight = "_do-7";
export var trackingLink = "_do-g";